// extracted by mini-css-extract-plugin
module.exports = {"songName":"SongName_songName__2n7N1","nameText":"SongName_nameText__2HSiQ"};